import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { kuangjiApi } from "../../api/kuangm-api";
import { getText } from "../../utils/util";
import ListPage from "./components/listPage";
import TopPage from "./components/topPage";
export default function LockUp() {
  const navigate = useNavigate();
  const uid = localStorage.getItem("uid");
  const [one, setOne] = useState();
  const [kjList, setKjList] = useState([] as any[]);
  const [userkjList, setUserKjList] = useState([] as any[]);
  const [userCoinInfo, setuserCoinInfo] = useState({});
  const [kjprofitSum, setKjprofitSum] = useState({});
  const [kjprofitOneSum, setKjprofitOneSum] = useState({});
  const { t: translate } = useTranslation();

  //kj列表
  const loadKJListData = async () => {
    const data = await kuangjiApi.pcList({ pageNum: 1, pageSize: 200 });
    if (data.ok) {
      setKjList(data.data.records);
      setOne(data.data.records[0]);
    }
  };

  //统计数据
  const loadKjprofitSumData = async () => {
    const data = await kuangjiApi.kjprofitSum({ uid });
    if (data.ok) {
      setKjprofitSum(data.data);
    }
  };

  //加载数据
  const loadData = async () => {
    loadKJListData();
    loadKjprofitSumData();
  };
  useEffect(() => {
    loadData();
  }, []);
  return (
    <div className="min-h-screen bg-neutral-900 w-full revert-style">
      <AcendexLayout
        hideBottomBar
        theme="light"
        pcTopBarTitle={translate(getText("理財產品"))}
        mobileTopBarTitle={translate(getText("理財產品"))}
      >
        <div className="container mx-auto">
          <TopPage kjprofitSum={kjprofitSum} />
          <ListPage kjList={kjList} />
        </div>
      </AcendexLayout>
    </div>
  );
}
